import { EpimsBaseEntityDto } from './epim-base.dto';
export class UserStaffDetailDto extends EpimsBaseEntityDto {

    LastName: string;
    FirstName: string;
    MiddleName: string;
    StaffName: string;
    TitleId: string;
    MaritalStatusId: string;
    Address: string;
    PhoneNo: string;
    EmailAddress: string;
    Occupation: string;
    SpouseName: string;
    NoOfChildren: number;
    NextOfKin: string;
    AcademicQualification: number;
    SubscriberEmail: string;
    ContractorId: number;
    StaffType: string;
    SubscriptionUserId: string;  
    Version: number;
}
